import { Container, LoadingOverlay, Spinner } from '@soteria/design-system-ve';

interface LoadingMessageProps {
  message?: string;
}

export function LoadingMessage({ message = 'Loading...' }: LoadingMessageProps) {
  return (
    <Container>
      <LoadingOverlay fullScreen message={message}>
        <Spinner size="large" />
      </LoadingOverlay>
    </Container>
  );
}
